import { render } from "./WjGauges.vue?vue&type=template&id=2da9d854"
import script from "./WjGauges.vue?vue&type=script&lang=js"
export * from "./WjGauges.vue?vue&type=script&lang=js"

import exportComponent from "/opt/buildagent/work/cdb5ff5a6ea0682/samples/reference-samples/config/vue3/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__